import { Box } from "@mui/material";
import { H4, H6 } from "../components/Typography";
import { FC } from "react";
import moment from "moment";
// root component interface
interface CardProps {
  data?: any;
}

const NomineeCard: FC<CardProps> = ({ data }) => {
  let transactionDate = moment(new Date(data?.nominee_dob)).format(
    "DD MMM YYYY"
  );
  let modified = moment(new Date(data?.modified_on)).format("DD MMM YYYY");
  return (
    <Box
      sx={{
        width: {
          md: "98%",
          xs: "92%",
        },
        background: "#F6F6F6",
        borderRadius: 2,
        p: {
          md: 2,
          xs: 1,
        },
        flexDirection: "row",
        display: "flex",
        justifyContent: "space-between",
        mt: 2,
      }}
    >
      <Box
        sx={{
          width: "98%",
          background: "#fff",
          borderRadius: 2,
          justifyContent: "space-between",
          display: "flex",
          flexDirection: {
            md: "row",
            xs: "column",
          },
        }}
      >
        <Box
          sx={{
            justifyContent: "center",
            alignItems: {
              md: "center",
              xs: "flex-start",
            },
            display: "flex",
            flexDirection: "column",
            width: {
              md: "25%",
              xs: "100%",
            },
            mt: {
              md: 0,
              xs: 1,
            },
            ml: {
              md: 0,
              xs: 2,
            },
            p: {
              md: 2,
              xs: 0,
            },
          }}
        >
          <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",

              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
            {data?.nominee_name}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
            Nominee Name
          </H6>
        </Box>
        <Box
          sx={{
            justifyContent: "center",
            alignItems: {
              md: "center",
              xs: "flex-start",
            },
            display: "flex",
            flexDirection: "column",
            width: {
              md: "25%",
              xs: "100%",
            },
            mt: {
              md: 0,
              xs: 1,
            },
            ml: {
              md: 0,
              xs: 2,
            },
          }}
        >
          <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",

              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
            {data?.nominee_relationship}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
            Nominee Relationship
          </H6>
        </Box>
        {/* Allocation */}
        <Box
          sx={{
            justifyContent: "center",
            alignItems: {
              md: "center",
              xs: "flex-start",
            },
            display: "flex",
            flexDirection: "column",
            width: {
              md: "25%",
              xs: "100%",
            },
            mt: {
              md: 0,
              xs: 1,
            },
            ml: {
              md: 0,
              xs: 2,
            },
          }}
        >
          <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
            {transactionDate}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
            DOB
          </H6>
        </Box>
        <Box
          sx={{
            justifyContent: "center",
            alignItems: {
              md: "center",
              xs: "flex-start",
            },
            display: "flex",
            flexDirection: "column",
            width: {
              md: "25%",
              xs: "100%",
            },
            mt: {
              md: 0,
              xs: 1,
            },
            ml: {
              md: 0,
              xs: 2,
            },
          }}
        >
          <H4
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
            }}
            fontWeight={"500"}
          >
            {`${data?.percentage} %` ?? ""}
          </H4>
          <H6
            sx={{
              fontFamily: "'Poppins', sans-serif",
              textAlign: "center",
              mt: 0.8,
              color: "#000000",
            }}
            fontWeight={"500"}
          >
            Allocation
          </H6>
        </Box>
        {/* Gaurdaian Name */}

        <Box
          sx={{
            justifyContent: "center",
            alignItems: {
              md: "center",
              xs: "flex-start",
            },
            display: "flex",
            flexDirection: "column",
            width: {
              md: "25%",
              xs: "100%",
            },
            mt: {
              md: 0,
              xs: 1,
            },
            ml: {
              md: 0,
              xs: 2,
            },
          }}
        >
          {data?.guardian_name !== "" && (
            <>
              <H4
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",

                  color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                }}
                fontWeight={"500"}
              >
                {data?.guardian_name}
              </H4>
              <H6
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                  mt: 0.8,
                  color: "#000000",
                }}
                fontWeight={"500"}
              >
                Guardian Name
              </H6>
            </>
          )}
        </Box>

        {/* Gaurdaian Name */}
        <Box
          sx={{
            justifyContent: "center",
            alignItems: {
              md: "center",
              xs: "flex-start",
            },
            display: "flex",
            flexDirection: "column",
            width: {
              md: "25%",
              xs: "100%",
            },
            mt: {
              md: 0,
              xs: 1,
            },
            ml: {
              md: 0,
              xs: 2,
            },
            mb: 2,
          }}
        >
          {data?.guardian_relationship !== "" && (
            <>
              <H4
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",

                  color: process.env.REACT_APP_BUTTON_ACTIVE_COLOR,
                }}
                fontWeight={"500"}
              >
                {data?.guardian_relationship}
              </H4>
              <H6
                sx={{
                  fontFamily: "'Poppins', sans-serif",
                  textAlign: "center",
                  mt: 0.8,
                  color: "#000000",
                }}
                fontWeight={"500"}
              >
                Guardian Relationship
              </H6>
            </>
          )}
        </Box>
        {/* Gaurdaian Name */}
      </Box>
    </Box>
  );
};

export default NomineeCard;
